import _ from 'lodash';
import {
    FETCH_JOKL_ORDERS,
    CLEAN_JOKL_ORDERS,
    SET_JOKL_ORDER_PAID,
    SET_JOKL_ORDER_PROCESSED,
    DELETE_JOKL_ORDER,
} from './types';
import { request, __ } from '../functions';

export const fetchJoklOrders = (screen, options = {}, id) => {
    const defaults = {
        page: 1,
        per_page: 0,
        filtered: {},
    };

    options = { ...defaults, ...options };

    let params = { page: options.page, per_page: options.per_page };

    // Nasetujeme filter
    _.forEach(options.filtered, (value, key) => {
        params = { ...params, ...{ [`filter_${key}`]: value } };
    });

    return dispatch => request(`/jokl/orders/${id}`, params).then(response => {
        const { data, sync } = response.data;
        const { setUser } = screen.props;

        // Nasetujeme user data
        setUser(sync.user);

        dispatch({ type: FETCH_JOKL_ORDERS, payload: data });
    });
};

export const setJoklOrderPaid = (screen, id) => {
    return dispatch => request(`/jokl/setPaidOrder/${id}`).then(response => {
        const { status } = response.data;

        if (status === 'error') {
            screen.showSnackbar('error', __('Nepodarilo sa zmeniť stav objednávky'));
            return;
        }

        screen.showSnackbar('success', __('Stav objednávky bol zmenený'));

        dispatch({ type: SET_JOKL_ORDER_PAID, payload: { id } });
    });
};

export const setJoklOrderProcessed = (screen, id) => {
    return dispatch => request(`/jokl/setProcessedOrder/${id}`).then(response => {
        const { status } = response.data;

        if (status === 'error') {
            screen.showSnackbar('error', __('Nepodarilo sa zmeniť stav objednávky'));
            return;
        }

        screen.showSnackbar('success', __('Stav objednávky bol zmenený'));

        dispatch({ type: SET_JOKL_ORDER_PROCESSED, payload: { id } });
    });
};

export const deleteJoklOrder = (screen, id) => {
    return dispatch => request(`/jokl/removeOrder/${id}`).then(response => {
        const { status } = response.data;

        if (status === 'error') {
            screen.showSnackbar('error', __('Objednávku sa nepodarilo zmazať'));
            return;
        }

        screen.showSnackbar('success', __('Objednávka bola zmazaná'));

        dispatch({ type: DELETE_JOKL_ORDER });
    });
};

export const cleanJoklOrders = () => ({ type: CLEAN_JOKL_ORDERS });
